import { type Experiment } from 'src/api/voisino/experiments.model'
import {
    FETCH_EXPERIMENTS,
    SET_EXPERIMENTS,
    SET_LOADING,
    SET_ERROR,
    CREATE_EXPERIMENT,
    ADD_EXPERIMENT,
    UPDATE_TEST_OUTCOME,
    UPDATE_TEST_IN_STORE,
} from 'src/redux/voisinoExperiments/voisinoExperiments.types'

export const fetchExperiments = () => ({ type: FETCH_EXPERIMENTS as typeof FETCH_EXPERIMENTS })
export const setExperiments = (experiments: Experiment[]) => ({
    type: SET_EXPERIMENTS as typeof SET_EXPERIMENTS,
    payload: experiments,
})
export const setLoading = (loading: boolean) => ({ type: SET_LOADING as typeof SET_LOADING, payload: loading })
export const setError = (error: string | null) => ({ type: SET_ERROR as typeof SET_ERROR, payload: error })

export const createExperiment = (experiment: Experiment) => ({
    type: CREATE_EXPERIMENT as typeof CREATE_EXPERIMENT,
    payload: experiment,
})
export const addExperiment = (experiment: Experiment) => ({
    type: ADD_EXPERIMENT as typeof ADD_EXPERIMENT,
    payload: experiment,
})

export const updateTestOutcome = (id: string, outcome: string, endDate?: string, lifecycleState?: string) => ({
    type: UPDATE_TEST_OUTCOME as typeof UPDATE_TEST_OUTCOME,
    payload: { id, outcome, endDate, lifecycleState },
})

export const updateTestInStore = (updated: Experiment) => ({
    type: UPDATE_TEST_IN_STORE as typeof UPDATE_TEST_IN_STORE,
    payload: updated,
})

export type VoisinoExperimentsAction =
    | ReturnType<typeof fetchExperiments>
    | ReturnType<typeof setExperiments>
    | ReturnType<typeof setLoading>
    | ReturnType<typeof setError>
    | ReturnType<typeof createExperiment>
    | ReturnType<typeof addExperiment>
    | ReturnType<typeof updateTestOutcome>
    | ReturnType<typeof updateTestInStore>
